import { useAppSelector } from "../../store/hooks";
import { GiHamburgerMenu } from "react-icons/gi";
import { useLocation } from "react-router-dom";
import Avatardropdown from "./avatarDropdown";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import Modal from "../modal";
import { useModal } from "../../customHooks/useModal";
import { IoIosClose } from "react-icons/io";
import { FaFileUpload } from "react-icons/fa";
import Breadcrumb from "./breadcrumb";
import Usedragdrop from "../../customHooks/useDragdrop";
import MainProfile from "../../pages/dashboard/profile/mainProfile";
import useMultipleImg from "../../customHooks/useMultipleImg";
import { Link } from "react-router-dom";

interface Props {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const Header = ({ setIsOpen }: Props) => {
  /* modal */
  /* test modal */
  const { isShown, toggle } = useModal();
  const { isShown: isShowProfile, toggle: ToggleProfile } = useModal();
  const {
    refInput,
    onChangefile,
    dragStatus,
    files,
    onDelete,
    errorFile,
    onClickDrag,
    onDrop,
    onDragOver,
    onDragLeave,
  } = Usedragdrop();
  /* End Modal */
  /* const { isShown, toggle }=useModal() */
  const dev = process.env.REACT_APP_DEVELOPMENT;
  const { pathname } = useLocation();
  let multiPathname = pathname.split("/");
  let paths = multiPathname.filter((path) => path.length > 0);
  let path_bread: string[] = [];
  path_bread[0] = paths[paths.length - 1];
  for (let index = 0; index < paths.length - 1; index++) {
    path_bread[index + 1] = paths[index];
  }
  const { name } = useAppSelector((state) => state.user);

  const Open = () => {
    setIsOpen(true);
  };

  return (
    <>
      <header className="c-header">
        <div className="c-header__box-options">
          {/* Header: Left side */}
          <span className="c-header__hamburger" onClick={Open}>
            <GiHamburgerMenu />
          </span>

          <div className="c-header__box-logo">
            <span className="c-header__title">PURLs Campaigns</span>
            <ol className="c-header__breadcrumb"></ol>
          </div>
          {/* Header: Right side */}
          <div className="c-header__options">
            {dev === "true" && (
              <div className="c-header__option">
                <span className="c-header__icon-option" onClick={toggle}>
                  <BsFillQuestionCircleFill />
                </span>
              </div>
            )}
            <div className="c-header__option">
              <span className="">{name}</span>
            </div>
            <Avatardropdown toggle={ToggleProfile} />
          </div>
        </div>
        <Breadcrumb />
      </header>
      <Modal
        isActive={isShowProfile}
        clouse={ToggleProfile}
        title="Profile Details"
      >
        <MainProfile />
      </Modal>
      <Modal isActive={isShown}>
        <div className="c-form-report">
          <span className="c-form-report__title">Write Us</span>
          <span className="c-form-report__subtitle">
            If you need more info, please check{" "}
            <span className="c-form-report__subtitle--blue">
              Support Guidelines.
            </span>
          </span>

          <div className="c-form-report__input-box">
            <span className="c-form-report__text-input">Subject</span>
            <input
              className="c-form-report__input-value"
              type="text"
              placeholder="Enter your question subject"
            />
          </div>

          <div className="c-form-report__input-box-two">
            <div className="c-form-report__input-two c-form-report__input-two--left">
              <span className="c-form-report__text-input">Subject</span>
              <select className="c-form-report__input-value">
                <option value="value2" selected>
                  PURLs
                </option>
              </select>
            </div>
            <div className="c-form-report__input-two">
              <span className="c-form-report__text-input">Type of Query</span>
              <select className="c-form-report__input-value">
                <option value="value2" selected>
                  Bug Detected
                </option>
              </select>
            </div>
          </div>

          <div className="c-form-report__input-box">
            <span className="c-form-report__text-input">Description *</span>
            <textarea
              className="c-form-report__input-value c-form-report__input-value--area"
              placeholder="Enter your question description"
            />
          </div>

          <div
            className={`
            c-form-report__attachments 
            ${dragStatus && "c-form-report__attachments--dragover"} 
            ${errorFile && "c-form-report__attachments--error"}
          `}
            onClick={onClickDrag}
            onDrop={(e) => onDrop(e, 5)}
            onDragOver={(e) => onDragOver(e)}
            onDragLeave={(e) => onDragLeave(e)}
          >
            <span className="c-form-report__icon">
              <FaFileUpload />
            </span>
            <div className="c-form-report__info">
              <span
                className={`c-form-report__info-title ${
                  errorFile && "c-form-report__info-title--error"
                }`}
              >
                {errorFile
                  ? errorFile
                  : dragStatus
                  ? "Drop your file"
                  : "Drop files here or click to Upload."}
              </span>
              <span className="c-form-report__info-text">
                Upload up to 5 files
              </span>
            </div>
            <input
              ref={refInput}
              type="file"
              accept="image/png,image/jpeg,application/pdf,image/jpg"
              onChange={(e) => onChangefile(e, 5)}
            />
          </div>
          <div className="c-form-report__box-files">
            {files.map(({ file, uuid }) => (
              <div className="c-form-report__file-name">
                {file.name}
                <span
                  className="c-form-report__delete-file"
                  onClick={() => onDelete(uuid)}
                >
                  <IoIosClose />
                </span>
              </div>
            ))}
          </div>
          <div className="c-form-report__footer">
            <button
              className="c-form-report__button-cancel c-form-report__button-cancel--left"
              onClick={toggle}
            >
              Cancel
            </button>
            <button className="c-form-report__button-submit">Submit</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;
